import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAIReplayDetectionVariables = Types.Exact<{
  input: Types.AIReplayDetectionInput;
}>;

export type RunAIReplayDetection = {
  aiReplayDetection: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'private' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAIReplayDetectionDocument = gql`
  mutation RunAIReplayDetection($input: AIReplayDetectionInput!) {
    aiReplayDetection(input: $input) {
      streamName
      streamId
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAIReplayDetectionMutationFn = Apollo.MutationFunction<
  RunAIReplayDetection,
  RunAIReplayDetectionVariables
>;

/**
 * __useRunAIReplayDetection__
 *
 * To run a mutation, you first call `useRunAIReplayDetection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAIReplayDetection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiReplayDetection, { data, loading, error }] = useRunAIReplayDetection({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAIReplayDetection(
  baseOptions?: Apollo.MutationHookOptions<RunAIReplayDetection, RunAIReplayDetectionVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAIReplayDetection, RunAIReplayDetectionVariables>(
    RunAIReplayDetectionDocument,
    options,
  );
}
export type RunAIReplayDetectionHookResult = ReturnType<typeof useRunAIReplayDetection>;
export type RunAIReplayDetectionMutationResult = Apollo.MutationResult<RunAIReplayDetection>;
export type RunAIReplayDetectionMutationOptions = Apollo.BaseMutationOptions<
  RunAIReplayDetection,
  RunAIReplayDetectionVariables
>;
export function mockRunAIReplayDetection({
  data,
  variables,
  errors,
}: {
  data: RunAIReplayDetection;
  variables?: RunAIReplayDetectionVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAIReplayDetectionDocument, variables },
    result: { data, errors },
  };
}
